export default __webpack_public_path__ + "assets/75782dec2926bf5bfcabf2c6673a846b.svg";